// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { spacing } from '@iheartjane/reefer-emotion';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import {
  RumErrorBoundary as ErrorBoundary,
  ErrorView,
  StoreSettingsSideNav,
} from '@jane/business-admin/components';

const Wrapper = styled.div({
  display: 'flex',
  ...spacing({ px: 64, py: 40 }),
});

const Main = styled.div({
  width: '85%',
});

export const StoreSettings = () => {
  return (
    <Suspense
      fallback={
        <Wrapper>
          <StoreSettingsSideNav />
        </Wrapper>
      }
    >
      <Wrapper>
        <StoreSettingsSideNav />
        <Main>
          <ErrorBoundary fallback={ErrorView} scope="stores.settings">
            <Outlet />
          </ErrorBoundary>
        </Main>
      </Wrapper>
    </Suspense>
  );
};
